<div class="principal">

  <div class="pantalla" [ngClass]="{'menuEstatico' : menuEstatico, 'menuAbierto' : menuAbierto && !menuEstatico}">

    <menuOpciones (MenuEstatico)="CambiarMenuEstatico($event)" (MenuAbierto)="CambiarMenuAbierto($event)"></menuOpciones>

    <div class="contenido-wrap">

      <div class="contenido">
        <router-outlet></router-outlet>
      </div>

    </div>

  </div>

</div>



